"use strict";
// import { EndpointInfo } from "./@types/types";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKET_METADATA_FIELDS = exports.getEndpointConfig = exports.URL_STUBS = exports.ENDPOINTS = exports.ENDPOINT_MAP = exports.MAINNET_USDC_MINT = exports.DEVNET_USDC_MINT = exports.PROGRAM_ID_PUBKEY = exports.PROGRAM_ID = exports.unlockedTokensMarketType = exports.formatSizeNumber = exports.formatPrice = exports.getMarketType = exports.CALLBACK_TYPES = exports.PREDICTION_MARKET_BUFFERS = exports.CANCEL_MARKET_TYPES = exports.MARKET_PRICE_STRINGS = exports.MARKET_TYPE_ORDER_STRINGS = exports.MARKET_TYPE_ORDER_AMOUNT = exports.GENERATE_ACCOUNT_TYPES = exports.CLOSE_ACCOUNT_TYPES = exports.CLOSE_ACCOUNTS_TRADE_YES = exports.CLOSE_ACCOUNTS_BUY_NO = exports.CLOSE_ACCOUNTS_SELL_NO = exports.REDEEM_TYPES = exports.INIT_MARKET_TYPES = exports.MARKET_TYPE_TO_TRADE_ACCOUNT = exports.TRADE_NO = exports.TRADE_YES = exports.MARKET_TYPE_TO_TRADE_ACCOUNT_KEY = exports.MARKET_TYPE = exports.getProgramOrder = exports.getBufferedOrder = exports.BUFFERED_ORDERS = exports.MarketsNotLoaded = exports.Side = exports.SideMap = exports.ORDER_TYPE = exports.CATEGORY_LIST_MAINNET = exports.CATEGORY_LIST_DEVNET = exports.CategoryEnums = void 0;
const lodash_1 = require("lodash");
const web3_js_1 = require("@solana/web3.js");
const types_1 = require("./generated/types");
const YesNoComponentKeys = {
    YES: "YES",
    NO: "NO",
    SELL: "SELL",
    // TO DO: swap to sell_no and sell_yes instead of matching manually
    SELL_NO: "SELL_NO_KEY",
    SELL_YES: "SELL_YES_KEY",
};
exports.CategoryEnums = {
    // HOT: "Hot",
    FINANCE: "Finance",
    POLITICS: "Politics",
    SPORTS: "Sports",
    CULTURE: "Culture",
    WORLD: "World",
    BUSINESS: "Business",
    RESOLVED: "Resolved",
    DOOMERS: "doomers",
};
exports.CATEGORY_LIST_DEVNET = [
    exports.CategoryEnums.FINANCE,
    exports.CategoryEnums.POLITICS,
    exports.CategoryEnums.DOOMERS,
    // CategoryEnums.BUSINESS,
    // CategoryEnums.SPORTS,
    // "Culture",
    exports.CategoryEnums.WORLD,
];
exports.CATEGORY_LIST_MAINNET = [""];
exports.ORDER_TYPE = {
    Limit: { limit: {} },
    ImmediateOrCancel: { immediateOrCancel: {} },
    PostOnly: { postOnly: {} },
};
const BID = new types_1.Side.Bid();
const ASK = new types_1.Side.Ask();
exports.SideMap = { bid: BID, ask: ASK, buy: BID, sell: ASK };
exports.Side = {
    buy: { bid: {} },
    sell: { ask: {} },
    bid: { bid: {} },
    ask: { ask: {} },
};
exports.MarketsNotLoaded = {
    title: "Markets are loading...",
    text: "Markets are loading...",
    ending_market: "Loading Market",
    no_volume: "n/a",
};
exports.BUFFERED_ORDERS = {
    TRADE_YES: "trade_yes",
    TRADE_NO: "trade_no",
    BUY_NO: "buy_no",
    SELL_NO: "sell_no",
};
const getBufferedOrder = (marketType) => {
    if (marketType === exports.MARKET_TYPE.BUY_YES || marketType === exports.MARKET_TYPE.SELL_YES)
        return Buffer.from(exports.BUFFERED_ORDERS.TRADE_YES);
    if (marketType === exports.MARKET_TYPE.BUY_NO)
        return Buffer.from(exports.BUFFERED_ORDERS.BUY_NO);
    if (marketType === exports.MARKET_TYPE.SELL_NO)
        return Buffer.from(exports.BUFFERED_ORDERS.SELL_NO);
    return "error";
};
exports.getBufferedOrder = getBufferedOrder;
const getProgramOrder = (marketType) => {
    if (marketType === exports.MARKET_TYPE.BUY_YES || marketType === exports.MARKET_TYPE.SELL_YES)
        return "tradeYesAccount";
    if (marketType === exports.MARKET_TYPE.BUY_NO)
        return "tradeNoAccount";
    if (marketType === exports.MARKET_TYPE.SELL_NO)
        return "tradeNoAccount";
    return "error";
};
exports.getProgramOrder = getProgramOrder;
const BUY_YES = "buyYes";
const SELL_YES = "sellYes";
const BUY_NO = "buyNo";
const SELL_NO = "sellNo";
exports.MARKET_TYPE = {
    BUY_YES,
    SELL_YES,
    BUY_NO,
    SELL_NO,
};
const TRADE_YES_ACCOUNT = "tradeYesAccount";
const TRADE_NO_ACCOUNT = "tradeNoAccount";
exports.MARKET_TYPE_TO_TRADE_ACCOUNT_KEY = {
    [exports.MARKET_TYPE.BUY_YES]: TRADE_YES_ACCOUNT,
    [exports.MARKET_TYPE.SELL_YES]: TRADE_YES_ACCOUNT,
    [exports.MARKET_TYPE.BUY_NO]: TRADE_NO_ACCOUNT,
    [exports.MARKET_TYPE.SELL_NO]: TRADE_NO_ACCOUNT,
};
exports.TRADE_YES = "tradeYes";
exports.TRADE_NO = "tradeNo";
exports.MARKET_TYPE_TO_TRADE_ACCOUNT = {
    [exports.MARKET_TYPE.BUY_YES]: exports.TRADE_YES,
    [exports.MARKET_TYPE.SELL_YES]: exports.TRADE_YES,
    [exports.MARKET_TYPE.BUY_NO]: exports.TRADE_NO,
    [exports.MARKET_TYPE.SELL_NO]: exports.TRADE_NO,
};
const INIT_TRADE_YES = "initTradeYes";
const INIT_BUY_NO = "initBuyNo";
const INIT_SELL_NO = "initSellNo";
exports.INIT_MARKET_TYPES = {
    INIT_TRADE_YES,
    INIT_BUY_NO,
    INIT_SELL_NO,
};
const REDEEM_WINNING_NO = "redeemWinningNo";
const REDEEM_WINNING_YES = "redeemWinningYes";
exports.REDEEM_TYPES = {
    REDEEM_WINNING_NO,
    REDEEM_WINNING_YES,
};
exports.CLOSE_ACCOUNTS_SELL_NO = "closeAccountsSellNo";
exports.CLOSE_ACCOUNTS_BUY_NO = "closeAccountsBuyNo";
exports.CLOSE_ACCOUNTS_TRADE_YES = "closeAccountsTradeYes";
exports.CLOSE_ACCOUNT_TYPES = {
    CLOSE_ACCOUNTS_SELL_NO: exports.CLOSE_ACCOUNTS_SELL_NO,
    CLOSE_ACCOUNTS_BUY_NO: exports.CLOSE_ACCOUNTS_BUY_NO,
    CLOSE_ACCOUNTS_TRADE_YES: exports.CLOSE_ACCOUNTS_TRADE_YES,
};
exports.GENERATE_ACCOUNT_TYPES = {
    ...exports.MARKET_TYPE,
    ...exports.REDEEM_TYPES,
    ...exports.CLOSE_ACCOUNT_TYPES,
    ...exports.INIT_MARKET_TYPES,
};
function MARKET_TYPE_ORDER_AMOUNT({ type, amount, }) {
    let stringAmount = amount.toString().replace(/^0+/, "");
    if (exports.MARKET_TYPE.BUY_YES === type) {
        return `buy ${stringAmount} yes`;
    }
    if (exports.MARKET_TYPE.SELL_YES === type) {
        return `sell ${stringAmount} yes`;
    }
    if (type === exports.MARKET_TYPE.BUY_NO) {
        return `buy ${stringAmount} no`;
    }
    if (exports.MARKET_TYPE.SELL_NO === type) {
        return `sell ${stringAmount} no`;
    }
}
exports.MARKET_TYPE_ORDER_AMOUNT = MARKET_TYPE_ORDER_AMOUNT;
exports.MARKET_TYPE_ORDER_STRINGS = {
    [BUY_YES]: "Buy Yes",
    [SELL_YES]: "Sell Yes",
    [BUY_NO]: "Buy No",
    [SELL_NO]: "Sell No",
};
exports.MARKET_PRICE_STRINGS = {
    [BUY_YES]: "Market price to buy YES",
    [SELL_YES]: "Market price to sell YES",
    [BUY_NO]: "Market price to buy NO",
    [SELL_NO]: "Market price to sell NO",
};
const CANCEL_TRADE_YES = "cancelTradeYes";
const CANCEL_BUY_NO = "cancelBuyNo";
const CANCEL_SELL_NO = "cancelSellNo";
exports.CANCEL_MARKET_TYPES = {
    [BUY_YES]: CANCEL_TRADE_YES,
    [SELL_YES]: CANCEL_TRADE_YES,
    [BUY_NO]: CANCEL_BUY_NO,
    [SELL_NO]: CANCEL_SELL_NO,
};
exports.PREDICTION_MARKET_BUFFERS = {
    USDC_VAULT: "usdc_vault",
    YES_MINT: "yes_mint",
    NO_MINT: "no_mint",
    FAKE_USDC_MINT: "f_usdc_mint",
    SERUM_MARKET: "serum_market",
    REQUEST_QUEUE: "request_queue",
    PC_VAULT: "pc_vault",
    COIN_VAULT: "coin_vault",
    UNLOCKED_NO: "unlocked_no",
    UNLOCKED_YES: "unlocked_yes",
    LOCKED_NO: "locked_no",
    LOCKED_FUSDC: "locked_f_usdc",
    LOCKED_YES: "locked_yes",
    OPEN_ORDERS: "open_orders",
};
const SUCCESS = "SUCCESS";
const FAIL = "FAIL";
exports.CALLBACK_TYPES = {
    SUCCESS,
    FAIL,
};
function getMarketType(buySellSelected, market) {
    if (market?.ownedTokens?.yesTokens?.uiAmount &&
        buySellSelected === YesNoComponentKeys.SELL) {
        return exports.MARKET_TYPE.SELL_YES;
    }
    if (market?.ownedTokens?.noTokens?.uiAmount &&
        buySellSelected === YesNoComponentKeys.SELL) {
        return exports.MARKET_TYPE.SELL_NO;
    }
    if (buySellSelected === YesNoComponentKeys.YES) {
        return exports.MARKET_TYPE.BUY_YES;
    }
    if (buySellSelected === YesNoComponentKeys.NO) {
        return exports.MARKET_TYPE.BUY_NO;
    }
}
exports.getMarketType = getMarketType;
// to do rewrite this so that the dependencies are clear for buyNo and bids
const formatPrice = (number, side = "bids", type, opts = {
    toFixedDigit: 1,
}, suffix = "¢", prefix = "") => {
    const { toFixedDigit } = opts;
    let num;
    if (type === exports.MARKET_TYPE.SELL_YES) {
        num = number * 100;
    }
    else if (type === exports.MARKET_TYPE.SELL_NO) {
        num = (1 - number) * 100;
    }
    else {
        num = side === "bids" ? (1 - number) * 100 : number * 100;
    }
    return `${prefix}${num.toFixed(toFixedDigit)}${suffix}`;
};
exports.formatPrice = formatPrice;
const formatSizeNumber = (num, obj = { noDecimal: false }) => {
    const { noDecimal } = obj;
    if (num > 99999) {
        return "99999+";
    }
    if (noDecimal) {
        return num.toFixed(0);
    }
    if (num >= 1000) {
        return num.toFixed(0);
    }
    if (num >= 100) {
        return num.toFixed(1);
    }
    return num?.toFixed(2);
};
exports.formatSizeNumber = formatSizeNumber;
//this is kind of spaghetti code but couldnt figure out another way to efficiently get the info to rerender without jenking up the prices.
function unlockedTokensMarketType({ selectedMarket, itemDetail }) {
    if (selectedMarket?.ownedTokens?.yesTokens?.uiAmount ||
        itemDetail?.ownedTokens?.yesTokens?.uiAmount) {
        return exports.MARKET_TYPE.SELL_YES;
    }
    if (selectedMarket?.ownedTokens?.noTokens?.uiAmount ||
        itemDetail?.ownedTokens?.noTokens?.uiAmount) {
        return exports.MARKET_TYPE.SELL_NO;
    }
    return "";
}
exports.unlockedTokensMarketType = unlockedTokensMarketType;
exports.PROGRAM_ID = "9TeS5Yqy3pN9Xphph2UzvVvRbZtqzVM3UvAaMDf6HhMQ";
exports.PROGRAM_ID_PUBKEY = new web3_js_1.PublicKey(exports.PROGRAM_ID);
exports.DEVNET_USDC_MINT = new web3_js_1.PublicKey("FCVjwQW1muwEzLGvcz4cRC7S82KzqvDmYMyasuK5cXp");
exports.MAINNET_USDC_MINT = new web3_js_1.PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v");
exports.ENDPOINT_MAP = {
    devnet: {
        name: "devnet",
        endpoint: "https://api.devnet.solana.com",
        custom: false,
        serumMarketId: "FSrM9nHBx8xnHBHfrmyj5eB5R2uAK2CoYE4tcT25R2am",
        usdcMintAddress: exports.DEVNET_USDC_MINT.toBase58(),
        categoryList: exports.CATEGORY_LIST_DEVNET,
    },
    devnet2: {
        name: "devnet",
        endpoint: "https://api.devnet.solana.com",
        custom: false,
        serumMarketId: "FSrM9nHBx8xnHBHfrmyj5eB5R2uAK2CoYE4tcT25R2am",
        usdcMintAddress: exports.DEVNET_USDC_MINT.toBase58(),
        categoryList: exports.CATEGORY_LIST_DEVNET,
    },
    localnet: {
        name: "localnet",
        endpoint: "http://localhost:8899",
        serumMarketId: "FSrM9nHBx8xnHBHfrmyj5eB5R2uAK2CoYE4tcT25R2am",
        usdcMintAddress: "GHJHLnpefm3CapekXWrN2ihwVnzG8q5toemf8R5A42dG",
        custom: false,
        categoryList: exports.CATEGORY_LIST_DEVNET,
    },
    mainnetBeta: {
        name: "mainnet-beta",
        endpoint: "https://solana-api.projectserum.com",
        custom: false,
        serumMarketId: "",
        categoryList: exports.CATEGORY_LIST_MAINNET,
        usdcMintAddress: exports.MAINNET_USDC_MINT.toBase58(),
    },
    mainnetBeta2: {
        name: "mainnet-beta",
        endpoint: "https://api.mainnet-beta.solana.com",
        custom: false,
        serumMarketId: "",
        categoryList: exports.CATEGORY_LIST_MAINNET,
        usdcMintAddress: exports.MAINNET_USDC_MINT.toBase58(),
    },
    mainnetBeta3: {
        name: "mainnet-beta",
        endpoint: "https://ssc-dao.genesysgo.net",
        custom: false,
        serumMarketId: "",
        categoryList: exports.CATEGORY_LIST_MAINNET,
        usdcMintAddress: exports.MAINNET_USDC_MINT.toBase58(),
    },
};
exports.ENDPOINTS = [
    exports.ENDPOINT_MAP.devnet,
    exports.ENDPOINT_MAP.devnet2,
    exports.ENDPOINT_MAP.localnet,
    exports.ENDPOINT_MAP.mainnetBeta,
    exports.ENDPOINT_MAP.mainnetBeta2,
];
exports.URL_STUBS = {
    ORDERBOOK: "/orderbook",
    HOME: "/",
    PORTFOLIO: "/portfolio",
};
function getEndpointConfig(endpoint, name) {
    const findEndpoint = (0, lodash_1.find)(exports.ENDPOINTS, (i) => {
        if (endpoint) {
            return i.endpoint === endpoint;
        }
        return i.name === name;
    });
    return {
        DEX_PID: new web3_js_1.PublicKey(findEndpoint.serumMarketId),
        USDC_MINT_ID: new web3_js_1.PublicKey(findEndpoint.usdcMintAddress),
        ENDPOINT: findEndpoint.endpoint,
        CATEGORY_LIST: findEndpoint.categoryList,
    };
}
exports.getEndpointConfig = getEndpointConfig;
exports.MARKET_METADATA_FIELDS = {
    description: types_1.MarketMetadataFields.Description,
    image: types_1.MarketMetadataFields.Image,
    rules: types_1.MarketMetadataFields.Rules,
    title: types_1.MarketMetadataFields.Title,
};
//# sourceMappingURL=consts.js.map